import { useEffect } from "react";

const SITE = "https://noyolaconstructionllc.com";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    if (title) { document.title = title; setMeta("property", "og:title", title); }
    if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); }
    const url = `${SITE}${path != null ? path : window.location.pathname}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
    link.setAttribute("href", url);
    setMeta("property", "og:url", url);
    let robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) { robots = document.createElement("meta"); robots.setAttribute("name", "robots"); document.head.appendChild(robots); }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, path, noindex]);
  return null;
};
